

















import Vue from "vue";
import { Prop } from "vue-property-decorator";
import Component from "vue-class-component";

@Component
export default class ElAvatar extends Vue {
	@Prop({ type: [Number, String], default: 0 }) radius!: number;
	@Prop({ type: String }) icon!: string;
	@Prop({ type: String }) src!: string;
	@Prop({ type: String }) url!: string;
	@Prop({ type: Number, default: 16 }) iconSize!: number;

	get styleRadius(): string {
		const radius = Math.abs(parseInt(String(this.radius)));
		if (
			Object.prototype.toString.call(radius) == "[object Number]" &&
			radius != NaN
		) {
			return `${radius}px`;
		}
		return "0px";
	}

	get styleImage(): string {
		const _icon: string = this.icon || this.src || this.url;
		if (
			/^https?:\/\//i.test(_icon) ||
			/(jpe?g|gif|png|webp)/i.test(_icon)
		) {
			return _icon;
		}
		return "";
	}

	get classIcon(): string {
		const _icon: string = this.icon || this.src || this.url;
		if (!this.styleImage && _icon) {
			return _icon;
		}
		return "";
	}

	get classIconSize(): string {
		const size = Math.abs(parseInt(String(this.iconSize)));
		if (
			Object.prototype.toString.call(size) == "[object Number]" &&
			size != NaN &&
			size > 16
		) {
			return `${size}px`;
		}
		return "16px";
	}

	get hasSlot(): boolean {
		return !!this.$slots.default;
	}
}
